/**
 * Calendar Arche Page
 *
 * Route wrapper: ArcheLayout + ArcheHeader + Routes for the calendar arche.
 */

import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { ArcheHeader } from '../../../components/ArcheHeader';
import { ARCHE_ID } from '../constants';
import { CalendarMainPage } from './CalendarMainPage';
import { AnalyticsPage } from './AnalyticsPage';
import { SyncCallbackPage } from './SyncCallbackPage';

export function CalendarArchePage() {
  return (
    <ArcheLayout>
      <div className="flex flex-col h-full">
        <ArcheHeader archeId={ARCHE_ID} title="Calendar" />
        <div className="flex-1 min-h-0 overflow-auto">
          <Routes>
            {/* OAuth popup redirect target for provider calendar sync —
                registered before the catch-all. */}
            <Route path="/sync/callback" element={<SyncCallbackPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/*" element={<CalendarMainPage />} />
          </Routes>
        </div>
      </div>
    </ArcheLayout>
  );
}
